import Image from 'next/image';
import { Dispatch, SetStateAction } from 'react';

import { Button } from '../../../ui';

export const Requirements = ({
  setCurrentStep,
  isLoading,
}: {
  setCurrentStep: Dispatch<
    SetStateAction<
      | 'REQUIREMENTS'
      | 'INTRODUCTION'
      | 'CAPITAL TYPES'
      | 'GROWTH PLAN'
      | 'FINANCIALS'
      | 'OWNERSHIP'
      | 'EBITDA'
      | 'AMOUNT NEEDED'
      | 'BREAKDOWN'
      | 'REVIEW'
      | 'CONFIRMATION'
    >
  >;
  isLoading: boolean;
}) => {
  return (
    <div className="flex gap-8">
      <div className="flex flex-col gap-4 flex-1">
        <div className="flex flex-col gap-2">
          <h3 className="text-xl font-bold">
            Welcome to Scaleup Capital Connector.
          </h3>
          <span>
            We&apos;re excited to assist you in securing the capital you need to
            grow your business.
          </span>
          <span>
            In order to complete your request, you need to have the following
            information:
          </span>
          <ul>
            <li className="flex gap-2">
              <div className="rounded-full bg-secondary-50 min-w-6 h-6 text-center">
                1
              </div>
              Your Supplier Growth Plan, business plan, strategic plan, action
              plan, or pitch deck.
            </li>
            <li className="flex gap-2">
              <div className="rounded-full bg-secondary-50 min-w-6 h-6 text-center">
                2
              </div>
              Your Financial Statements: P&L/Income Statement, Balance Sheet,
              and Cash Flow Statements for the past three years.
            </li>
            <li className="flex gap-2">
              <div className="rounded-full bg-secondary-50 min-w-6 h-6 text-center">
                3
              </div>
              Total Amount Needed: The total dollar amount you are requesting.
            </li>
            <li className="flex gap-2">
              <div className="rounded-full bg-secondary-50 min-w-6 h-6 text-center">
                4
              </div>
              <div className="flex flex-col">
                Detailed Uses of the Funds: Breakdown of how the funds will be
                used:
                <ul className="list-disc list-inside">
                  <li>Building inventory</li>
                  <li>Buying another company</li>
                  <li>Buying new equipment</li>
                  <li>Financing receivables</li>
                  <li>Hiring operations people</li>
                  <li>Hiring sales people</li>
                  <li>Purchasing property</li>
                  <li>Refinancing/distributing to owner(s)</li>
                </ul>
              </div>
            </li>
          </ul>
        </div>

        <div>
          <Button
            text="Continue"
            variant={!isLoading ? 'primary' : 'disabled'}
            suffixIcon="/icons/arrow_right.svg"
            onClick={() => setCurrentStep('INTRODUCTION')}
          />
        </div>
      </div>
      <div className="flex flex-1 justify-center">
        <Image
          src="/create_cr.png"
          alt="Capital Request Image"
          priority
          width={512}
          height={584}
          style={{ objectFit: 'contain' }}
        />
      </div>
    </div>
  );
};
